export enum MediaFileTypes {
  TRACK = 0,
  PROMO = 1,
  VIDEO = 5,
  IMAGE = 6,
  VIDEO_PROMO = 8,
  IMAGE_PROMO = 9,
}
